// extracted by mini-css-extract-plugin
export default {"section":"AccessWithoutConsentDialog_section__3D5rP","textbox":"AccessWithoutConsentDialog_textbox__rEldm","label":"AccessWithoutConsentDialog_label__sOVji"};